// extracted by mini-css-extract-plugin
export default {"widget":"ShortcutsWidget__widget--Oom0K","title":"ShortcutsWidget__title--g0lJ3"};